import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface Project {
  key: string;
  id: string;
  name: string;
  description: string;
  type: string;
  lastUpdated: string;
}
 
interface ModalState {
    isProjectListOpen: boolean;
    selectedProjectData: Project | null;
}
 
const initialState: ModalState = {
  isProjectListOpen: false,
  selectedProjectData:null

 
};
 
const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openProjectListingModal: (state) => {
      state.isProjectListOpen = true;
    },
    closeProjectListingModal: (state) => {
      state.isProjectListOpen = false;
    },
    selectedProjectDataAction:(state, action: PayloadAction<Project | null>) => {
        state.selectedProjectData = action.payload
    }
   
  },
});
 
export const { openProjectListingModal, closeProjectListingModal ,selectedProjectDataAction} = modalSlice.actions;
export default modalSlice.reducer;